import moment from 'moment';
import { CartServiceType } from '../store/shoppingCart/shoppingCartStore';
import type { AppliedCouponResponseDTO } from '../DTO/checkoutResponseDTO';

export const toTitleString = (rawString: string) => {
    return rawString[0].toUpperCase() + rawString.slice(1);
};

export const addDaysToDate = (date: Date, numberOfDays: number) => {
    const newValue = moment(date);
    newValue.add({ day: numberOfDays });
    return newValue.toDate();
};

export const addMonthsToDate = (date: Date, numberOfMonths: number) => {
    const newValue = moment(date);
    newValue.add({ month: numberOfMonths });
    return newValue.toDate();
};


export enum WaveLevelEnum {
    BAY = 'Bay',
    REEF = 'Reef',
}

export enum SectionsEnum {
    SECTIONS = 'Sessões',
    TIKECETS = 'Ingressos',
    // SERVICES = 'Serviços',
}

export const sectionsConst = Object.values(SectionsEnum);

export function redirectToWhatsapp(exhibitionName: string) {
    window.open(
        `https://wa.me/${import.meta.env.VITE_SURFLAND_NUMBER}?text=Olá,%20tenho%20dúvidas%20sobre%20a%20exibição%20${encodeURIComponent(exhibitionName)}`,
        '_blank'
    );
}

export function getCartType(cartType: CartServiceType): string {
    switch (cartType) {
        case CartServiceType.Waves:
            return 'wave';
        case CartServiceType.Tickets:
            return 'ticket';
        case CartServiceType.Park:
            return 'park';
        default:
            return 'service';
    }
}

export function redirectOwnerSearch(token?: string) {
    const url = new URL(import.meta.env.VITE_OWNER_URL);

    if (token) {
        url.searchParams.append('message', 'redirect.token.lp');
        url.searchParams.append('data', token);
    } else {
        url.searchParams.append('message', 'create-account');
    }

    window.open(url.toString(), '_blank');
}

export function redirectYourTickets(token?: string) {
    const url = new URL(import.meta.env.VITE_OWNER_URL + '/ticket');

    if (token) {
        url.searchParams.append('message', 'redirect.token.lp');
        url.searchParams.append('data', token);
    } else {
        url.searchParams.append('message', 'create-account');
    }

    window.open(url.toString(), '_blank');
}

export function validateCPFCNPJ(value: string, onlyCPF?: boolean): boolean {
    value = value.replace(/\D/g, '');
  
    if(value.length === 11 && !/^(\d)\1{10}$/.test(value)) {  
        let soma = 0;
        let peso = 10;
        for (let i = 0; i < 9; i++) {
        soma += parseInt(value[i]) * peso--;
        }
        let resto = soma % 11;
        const digito1 = resto < 2 ? 0 : 11 - resto;
        if (parseInt(value[9]) !== digito1) {
        return false;
        }
    
        soma = 0;
        peso = 11;
        for (let i = 0; i < 10; i++) {
        soma += parseInt(value[i]) * peso--;
        }
        resto = soma % 11;
        const digito2 = resto < 2 ? 0 : 11 - resto;
        return parseInt(value[10]) === digito2;
    } else if(!onlyCPF && value.length === 14 && !/^(\d)\1{13}$/.test(value)) {
        value = value.replace(/\D/g, '');
    
        if (value.length !== 14 || /^(\d)\1{13}$/.test(value)) {
        return false;
        }
    
        let soma = 0;
        const peso = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        for (let i = 0; i < 12; i++) {
        soma += parseInt(value[i]) * peso[i + 1];
        }
        let resto = soma % 11;
        const digito1 = resto < 2 ? 0 : 11 - resto;
        if (parseInt(value[12]) !== digito1) {
        return false;
        }
    
        soma = 0;
        for (let i = 0; i < 13; i++) {
        soma += parseInt(value[i]) * peso[i];
        }
        resto = soma % 11;
        const digito2 = resto < 2 ? 0 : 11 - resto;
        return parseInt(value[13]) === digito2;
    }

    return false;
}
/**
 * Calcula o valor efetivo do desconto baseado no cupom aplicado
 * @param coupon - O cupom aplicado
 * @param cartTotal - O valor total do carrinho
 * @returns O valor do desconto em reais
 */
export function calculateEffectiveDiscount(
    coupon: AppliedCouponResponseDTO | null,
    cartTotal: number
): number {
    if (!coupon) return 0;
    
    if (coupon.discountValue > 0) {
        return coupon.discountValue;
    }
    
    if (coupon.percentage && coupon.percentage > 0) {
        return (cartTotal * coupon.percentage) / 100;
    }
    
    return 0;
}